import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';

//获得自产/代加工
export async function getScorderList(params) {
    return post(erpserver+'/scorder/getScorderList', params, true)
}


